// extracted by mini-css-extract-plugin
export default {"optionsMenu":"languageSelect_optionsMenu__+6OTR","optionMenu":"languageSelect_optionMenu__7Bman","LanguageSelected":"languageSelect_LanguageSelected__bKL-k"};